import slide1 from "../../assets/banner/1.jpg";
import slide2 from "../../assets/banner/2.jpg";
import slide3 from "../../assets/banner/3.jpg";
export const sliderData = [
  {
    image: slide1,
    heading: "Sweet",
    desc: "Fill it right now",
  },
  {
    image: slide2,
    heading: "Delicious",
    desc: "Fill it right now",
  },
  {
    image: slide3,
    heading: "Tasty",
    desc: "Fill it right now",
  },
];
